import { Controller } from "@hotwired/stimulus"

// Bulk add / replace users on a standard team. Opened from the page header
// action menu; the form submits as a Turbo Stream and the response fills the
// status target (which polls itself via upload-poll).
export default class extends Controller {
  static targets = ["overlay", "form", "status"]

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundHandleKeydown)

    const textarea = this.formTarget.querySelector("textarea")
    if (textarea) {
      setTimeout(() => textarea.focus(), 100)
    }
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundHandleKeydown)

    this.formTarget.reset()
    if (this.hasStatusTarget) {
      this.statusTarget.innerHTML = ""
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
